import { useState } from "react";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { Values } from "@/components/Values";
import { ConsultingApproach } from "@/components/ConsultingApproach";
import { AboutUs } from "@/components/AboutUs";
import { StefanKaiserSection } from "@/components/StefanKaiserSection";
import { Testimonials } from "@/components/Testimonials";
import { QuoteForm } from "@/components/QuoteForm";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";

const Index = () => {
  const [language, setLanguage] = useState<'en' | 'de'>('en');
  const [showQuoteForm, setShowQuoteForm] = useState(false);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'de' : 'en');
  };

  const handleRequestQuote = () => {
    setShowQuoteForm(true);
  };

  const handleCloseQuoteForm = () => {
    setShowQuoteForm(false);
  };

  return (
    <div className="min-h-screen">
      <SEO language={language} />
      <Header 
        language={language} 
        onLanguageToggle={toggleLanguage}
        onRequestQuote={handleRequestQuote}
      />
      
      <main>
        <Hero language={language} onRequestQuote={handleRequestQuote} />
        <Services language={language} />
        <Testimonials language={language} />
        <Values language={language} />
        <ConsultingApproach language={language} />
        <AboutUs language={language} />
        <StefanKaiserSection language={language} />
      </main>

      <Footer language={language} />

      {showQuoteForm && (
        <QuoteForm language={language} onClose={handleCloseQuoteForm} />
      )}
    </div>
  );
};

export default Index;